<template>
    <intelligence-shell
        :title="$t('pages.intelligence.provider_performance.title')"
        :subtitle="$t('pages.intelligence.provider_performance.subtitle')"
        @filters-change="onFiltersChange"
    >
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.provider_performance.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.provider_performance.error') }}
        </div>

        <template v-else-if="providerPerformance">
            <intelligence-provider-performance-kpi-cards
                :kpis="providerPerformance.kpis"
            ></intelligence-provider-performance-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-provider-performance-chart
                    :providers="providerPerformance.providers"
                ></intelligence-provider-performance-chart>
                <intelligence-provider-performance-table
                    :providers="providerPerformance.providers"
                ></intelligence-provider-performance-table>
            </div>
        </template>
    </intelligence-shell>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceShell from 'components/page-elements/intelligence/IntelligenceShell'
    import IntelligenceProviderPerformanceKpiCards from 'components/page-elements/intelligence/IntelligenceProviderPerformanceKpiCards'
    import IntelligenceProviderPerformanceChart from 'components/page-elements/intelligence/IntelligenceProviderPerformanceChart'
    import IntelligenceProviderPerformanceTable from 'components/page-elements/intelligence/IntelligenceProviderPerformanceTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceShell,
            IntelligenceProviderPerformanceKpiCards,
            IntelligenceProviderPerformanceChart,
            IntelligenceProviderPerformanceTable,
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                providerPerformance: null,
                filters: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.provider_performance.title')
            },
        },

        methods: {
            onFiltersChange(filters) {
                this.filters = filters
                this.loadProviderPerformance()
            },

            loadProviderPerformance() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getProviderPerformance(this.filters)
                    .then((response) => {
                        this.providerPerformance = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.providerPerformance = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
